/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { Controller } from 'react-hook-form'
import { Box, FormControl, FormHelperText, useTheme } from '@mui/material'
import { get } from 'lodash'

export default function InputMultipleAutoComplete(props: any) {
  const {
    name: inputName,
    label,
    form,
    options,
    entries,
    name,
    groupBy,
  } = props
  const [defaultValue, setDefaultValue] = useState<any>([])
  const { watch } = form
  const theme = useTheme()

  useEffect(() => {
    const value = form.getValues()[name]
    const filteredArray = options.filter((item: any) =>
      value?.includes(get(item, entries[0])),
    )
    setDefaultValue(filteredArray)
  }, [form, options])

  useEffect(() => {
    const subscription = watch((value: any, { name: inputName, type }: any) => {
      if (!type && !inputName && name) {
        //setDefaultValue([])
      }
    })
    return () => subscription.unsubscribe()
  }, [watch])

  return (
    <Controller
      name={inputName}
      control={form.control}
      render={({
        field: { onChange, value, ...rest },
        fieldState: { error, ...state },
      }: any) => {
        const hasError = !!error

        return (
          <FormControl fullWidth error={hasError}>
            <Autocomplete
              size="small"
              multiple
              options={options}
              groupBy={(option) => (groupBy ? get(option, groupBy) : '')}
              getOptionLabel={(option: any) => get(option, entries[1])}
              value={defaultValue}
              renderGroup={(params) => (
                <div key={params.group}>
                  {groupBy && (
                    <Box
                      sx={{
                        px: 1,
                        mb: 1,
                        py: 1,
                        bgcolor: theme.palette.secondary.main,
                        color: 'white',
                      }}
                    >
                      {params.group}
                    </Box>
                  )}
                  <span>{params.children}</span>
                </div>
              )}
              isOptionEqualToValue={(option, value) => {
                return get(option, entries[0]) === get(value, entries[0])
              }}
              onChange={(v, t) => {
                setDefaultValue(t)
                onChange(t.map((item) => get(item, entries[0])))
              }}
              renderInput={(params: any) => (
                <TextField
                  error={hasError}
                  {...params}
                  InputLabelProps={{
                    ...params.InputLabelProps,
                    shrink: true,
                  }}
                  label={label}
                />
              )}
              sx={{ width: '100%' }}
            />
            {hasError && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )
      }}
    />
  )
}
